import React, { forwardRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
// import '../../css/certificate.css';

const Certificate = forwardRef(
  (
    { backgroundImage, logoImage, topMarginFrame, studentPhoto, student },
    ref
  ) => {
    return (
      <div className="container">
        {/* Certificate wrapper MUST be relative */}
        <div
          ref={ref}
          className="body"
          style={{
            direction: 'rtl',
            position: 'relative',
            width: '100%',
            minHeight: '100vh',
            pageBreakAfter: 'always', // IMPORTANT for print/PDF
          }}
        >
          {/* Background Frame */}
          {backgroundImage && (
            <img
              src={backgroundImage}
              alt="Certificate Frame"
              style={{
                position: 'absolute',
                inset: 0,
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                zIndex: 0,
              }}
            />
          )}

          {/* Content */}
          <div
            className="certificate-box"
            style={{
              paddingTop: `${topMarginFrame}px`,
              paddingBottom: `${topMarginFrame * 0.8}px`,
              paddingLeft: `${topMarginFrame}px`,
              paddingRight: `${topMarginFrame}px`,

              position: 'relative',
              zIndex: 1,
            }}
          >
            {/* HEADER */}
            <div className="row">
              <div className="col-5 text-center">
                <h2 className="jamhuuriya-arabic" style={{ color: '#66318d' }}>
                  جمهـورية الصـومـال الفيدرالية
                </h2>
                <h2 style={{ color: 'blue' }}>رابطـة المعـاهـد</h2>
                <h3 style={{ color: 'blue' }}>الشّـرعيـة فـي الصـومـال</h3>
              </div>

              <div className="col-2 text-center">
                {logoImage && (
                  <img src={logoImage} width="160" height="140" alt="Logo" />
                )}
              </div>

              <div className="col-5 text-center">
                <h4 style={{ color: '#66318d' }}>
                  Jamhuuriyadda Federaalka Soomaaliya
                </h4>
                <h3 style={{ color: 'blue' }}>
                  Xiriirka Macaahidda
                  <br />
                  Sharciga ee Soomaaliya
                </h3>
              </div>
            </div>

            {/* BODY */}
            <div className="row std-img-title">
              <div className="col-10">
                <h1 className="certificate-title">شهادة ثانوية شرعية</h1>
                <div className="certificate-top-body">
                  <p>
                    الحمد لله رب العالمين ، والصلاة والسّلام على نبينا محمّد
                    وعلى آله وصحبه أجمعين ، أمّا بعد:
                  </p>
                  <p>
                    فإن رابطة المعاهد الشّرعية في الصومال تشهد بأن الطالبة:{' '}
                    <span className="names"> {student.student} </span> المولودة
                    في: <span className="names">{student.pob}</span> عام:{' '}
                    <span className="names">{student.dob}</span>م.
                  </p>
                </div>
              </div>

              <div
                className="col-2 text-center"
                style={{ marginRight: '-20px' }}
              >
                {studentPhoto && (
                  <img
                    src={studentPhoto}
                    width="120"
                    height="140"
                    alt="Student"
                  />
                )}
              </div>
            </div>
            <div className="certificate-body">
              <p>
                اسم الأم: <span className="names">منة عبدالله اسماعيل</span> قد
                أتمت الدراسة الثانوية في:{' '}
                <span className="names">{student.school}</span> ونجحت في
                الامتحان النهائي للعام الدراسي{' '}
                <span className="taariikh">{student.graduateeyear}هـ</span>{' '}
                <span className="taariikh">
                  الموافق {student.graduatedate}م
                </span>{' '}
                بتقدير: <span className="names">{student.grade}</span> وبناء على
                ذلك قررت الرابطة منحها هذه الشّهادة.
              </p>
            </div>
            {/* FOOTER */}
            <div className="row ">
              <div className="col-5">
                <p className="xurirat">
                  حررت بتاريخ: <span className="date-num">1</span>{' '}
                  <span className="date-num">رجب</span>{' '}
                  <span className="date-num">1447</span>هـ
                </p>
                <p className="xurirat">سجلت برقم: 29983</p>
                <p className="mulaaxada">
                  ملاحظة: أي كشط أو تغيير في هذه الشهادة يلغيها
                </p>
              </div>
              <div className="col-3 text-center">
                <p className="signature-title">رئيس قسم الامتحانات</p>
                <p>...............................................</p>
              </div>
              <div className="col-1"></div>
              <div className="col-3 text-center">
                <p className="signature-title">رئيس الرابطة</p>
                <p>..............................................</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
);

export default Certificate;
